import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../stores/store';
import ListLayout from '../../../Generic/ListLayout';
import DataTable from '../../../Generic/DataTable';
import confirmDeleteDialog from '../../../Generic/confirmDeleteDialog';
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import useDeleteItem from '../../../../hooks/useDeleteItem';
import useFilterData from '../../../../hooks/useFilterData';
import useFetchData from '../../../../hooks/useFetchData';
import useLocalizedTextsMap from '../../../../hooks/useLocalizedTextsMap';
import { useSetMenu } from "../../../../hooks/useSetMenu";
import { createActiveColumn, createActionColumn, createGeneralColumn } from '../../../Generic/dataGridColumns';

const List = () => {
  const axiosPrivate = useAxiosPrivate();
  const { mainStore, mcdmMethodStore } = useStore();
  const { t } = useTranslation();
  const localizedTextsMap = useLocalizedTextsMap();
  useSetMenu(mainStore.MCDMMethodsAdminMenuType, mainStore.MCDMMethodsAdminMenuNo);
  const [columns, setColumns] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  useFetchData(axiosPrivate, `/MCDMMethods`, mcdmMethodStore);
  const filteredData = useFilterData(toJS(mcdmMethodStore.mcdmMethods), searchQuery);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const deleteItem = useDeleteItem(axiosPrivate, '/MCDMMethods', mcdmMethodStore.deleteItem);

  const remove = useCallback((id) => {
    confirmDeleteDialog(t, deleteItem, id);
  }, [deleteItem, t]);

  const cols = useMemo(() => [
    createGeneralColumn("methodOrder", "order", t, 80),
    createGeneralColumn("acronym", "acronym", t, 120),
    createGeneralColumn("fullNameEN", "fullName", t, 200),
    createActiveColumn(t),
    createActionColumn(t, "/Admin/MCDMMethods/Edit", remove),
  ].filter(Boolean), [t, remove]);

  useEffect(() => {
    setColumns(cols);
    // eslint-disable-next-line
  }, [t]);

  return (
    <>
      <ListLayout
        title={t("mcdmMethodsListTitle") || "MCDM Methods"}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        searchPlaceholder={t("searchPlaceholder")}
        addButtonLink="/Admin/MCDMMethods/Add"
        addButtonTitle={t("add")}
      >
        <DataTable
          rows={filteredData}
          columns={columns}
          pageSize={pageSize}
          setPageSize={setPageSize}
          localeTextsMap={localizedTextsMap}
        />
      </ListLayout>
    </>
  );
};

export default observer(List);
